// src/utils/indexedDB.js
class IndexedDB {
    constructor(dbName, version) {
      this.dbName = dbName;
      this.version = version;
      this.db = null;
    }
  
    // 打开数据库
    openDB(storeName, keyPath, indexes = []) {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(this.dbName, this.version);
  
        request.onerror = (event) => {
          reject(`IndexedDB 打开失败: ${event.target.error}`);
        };
  
        request.onsuccess = (event) => {
          this.db = event.target.result;
          resolve(this.db);
        };
  
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains(storeName)) {
            const store = db.createObjectStore(storeName, { keyPath });
            indexes.forEach(index => {
              store.createIndex(index.name, index.keyPath, { unique: index.unique });
            });
          }
        };
      });
    }
  
    // 添加数据
    addItem(storeName, item) {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([storeName], 'readwrite');
        const store = transaction.objectStore(storeName);
        
        const request = store.add(item);
        
        request.onsuccess = () => resolve('数据添加成功');
        request.onerror = (event) => reject(`添加失败: ${event.target.error}`);
      });
    }
  
    // 获取数据
    getItem(storeName, key) {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([storeName], 'readonly');
        const store = transaction.objectStore(storeName);
        
        const request = store.get(key);
        
        request.onsuccess = () => resolve(request.result);
        request.onerror = (event) => reject(`获取失败: ${event.target.error}`);
      });
    }
  
    // 更新数据
    updateItem(storeName, item) {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([storeName], 'readwrite');
        const store = transaction.objectStore(storeName);
        
        const request = store.put(item);
        
        request.onsuccess = () => resolve('数据更新成功');
        request.onerror = (event) => reject(`更新失败: ${event.target.error}`);
      });
    }
  
    // 删除数据
    deleteItem(storeName, key) {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([storeName], 'readwrite');
        const store = transaction.objectStore(storeName);
        
        const request = store.delete(key);
        
        request.onsuccess = () => resolve('数据删除成功');
        request.onerror = (event) => reject(`删除失败: ${event.target.error}`);
      });
    }
  
    // 获取所有数据
    getAllItems(storeName) {
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([storeName], 'readonly');
        const store = transaction.objectStore(storeName);
        
        const request = store.getAll();
        
        request.onsuccess = () => resolve(request.result);
        request.onerror = (event) => reject(`获取所有数据失败: ${event.target.error}`);
      });
    }
  }
  
  export default IndexedDB;